import React, { ComponentType, PropsWithChildren } from 'react'
import { AppLoading } from 'live/components/ui/Loading'

export const SuspenseWrapper = ({ children }: PropsWithChildren<React.ReactChildren>): JSX.Element => {
    return <React.Suspense fallback={<AppLoading />}>{children}</React.Suspense>
}

export function withSuspenseWrapper<P>(Component: ComponentType<P>): ComponentType<P> {
    const WrappedBySuspense: React.FC<P> = props => (
        <SuspenseWrapper>
            <Component {...props} />
        </SuspenseWrapper>
    )

    return WrappedBySuspense
}
